import React, { useState, useEffect, useContext, useRef } from "react";
import { Spin, Table } from "antdv5";
import Container from "components/common/Container";
import DefaultLayout from "components/layout/DefaultLayout";
import useAPI from "components/customHook/useApi";
import { TableOutter } from "../styles/DeviceList";
import FunctionBar from "components/pages/DeviceList/FunctionBar";
import EditableForm from "components/pages/DeviceList/EditableForm";
import type { IDevice } from "../api_types";
import type { Obj } from "../client_types";
import useEffectOnce from "components/customHook/useEffectOnce";
import { context } from "components/context/Context";
import { GETJsonDeviceList, POSTJsonDeviceListEdit } from "../api";

const DeviceList = () => {
  const { state, dispatch } = useContext(context);
  const {
    loading: spinLoading,
    preventRefreshCount,
    handleAuth,
    handleEnter,
    clubList,
  } = useAPI();
  const [selected, setSelected] = useState<React.Key[]>([]);
  const [deviceList, setDeviceList] = useState<(IDevice & { rank: number })[]>(
    []
  );
  const [editable, setEditable] = useState(false);
  const [show, setShow] = useState(false);
  const [updateValue, setUpdateValue] = useState({
    Gid: localStorage.getItem("gid") || "",
    DeviceUUID: "",
    Did: "",
    DeviceName: "",
  });
  const [addItem, setAddItem] = useState<{
    DeviceUUID: string;
    DeviceName: string;
    Gid?: string;
  }>({
    DeviceUUID: "",
    DeviceName: "",
  });
  const [loading, setLoading] = useState(false);
  const [uploadData, setUploadData] = useState<any>(null);
  const [fileDetail, setFileDetail] = useState(false);
  const [uploadType, setUploadType] = useState(0);
  const [mutipleShow, setMutipleShow] = useState(false);
  const [checked, setChecked] = useState(false);

  const columns = [
    {
      title: "序号",
      dataIndex: "rank",
      width: 100,
      sorter: (a: IDevice & { rank: number }, b: IDevice & { rank: number }) =>
        a.rank - b.rank,
      onCell: () => ({
        style: {
          minWidth: 100,
        },
      }),
    },
    {
      title: "踏板名称",
      dataIndex: "DeviceName",
      width: 150,
      sorter: (a: IDevice, b: IDevice) =>
        a.DeviceName.localeCompare(b.DeviceName),
    },
    {
      title: "踏板ID",
      dataIndex: "DeviceUUID",
      width: 150,
      sorter: (a: IDevice, b: IDevice) =>
        a.DeviceUUID.localeCompare(b.DeviceUUID, "en"),
    },
    {
      title: "新增时间",
      dataIndex: "Date",
      width: 150,
      render: (text: string) => <div>{text.replace(/T/g, " ")}</div>,
      sorter: (a: IDevice, b: IDevice) =>
        Date.parse(a.Date) - Date.parse(b.Date),
    },
    {
      title: "最后修改时间",
      dataIndex: "Updated",
      width: 150,
      render: (text: string) => <div>{text.replace(/T/g, " ")}</div>,
      sorter: (a: IDevice, b: IDevice) =>
        Date.parse(a.Updated) - Date.parse(b.Updated),
    },
    {
      title: "操作",
      dataIndex: "",
      width: 80,
      render: (text: string, record: IDevice) => [
        <div
          className="btn"
          key="edit"
          onClick={() => {
            setEditable(!editable);
            setUpdateValue({
              Gid: localStorage.getItem("gid") || "",
              DeviceUUID: record.DeviceUUID,
              Did: record.Did.toString(),
              DeviceName: record.DeviceName,
            });
          }}
        >
          修改
        </div>,
        <div
          className="btn"
          key="delete"
          onClick={() => {
            let result = window.confirm("确定删除？");
            if (result === true) {
              removeDevice(record);
            } else {
              return false;
            }
          }}
        >
          删除
        </div>,
      ],
    },
  ];

  const selectOnChange = (selectedRowKey: React.Key[]) => {
    setSelected(selectedRowKey);
  };
  const fetchDevice = () => {
    setLoading(true);
    const onAuth = localStorage.getItem("onAuth");
    const token = localStorage.getItem("token") || "";
    const gid = localStorage.getItem("gid") || "";
    if (onAuth === "true" && gid !== "") {
      GETJsonDeviceList(gid, token).then((res) => {
        if (res.Data !== null && res.Data.length !== 0) {
          let result: (IDevice & { rank?: number })[] = [
            ...res.Data,
          ] as IDevice[];
          for (let i = 0; i < res.Data.length; i++) {
            result[i] = { ...res.Data[i], rank: i + 1 };
          }
          setDeviceList(result as (IDevice & { rank: number })[]);
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
    } else {
      setLoading(false);
    }
  };
  const updateDevice = () => {
    const onAuth = localStorage.getItem("onAuth") || "";
    const gid = localStorage.getItem("gid") || "";
    const token = localStorage.getItem("token") || "";
    setLoading(true);
    if (onAuth === "true" && gid !== "") {
      POSTJsonDeviceListEdit(token, updateValue).then((res) => {
        if (res.InfoGet[0].Status === "Success") {
          setEditable(false);
          // why is the object passed to fetchDevice?
          fetchDevice();
          alert(res.InfoGet[0].Desc);
          setLoading(false);
        } else {
          alert(res.InfoGet[0].Desc);
          setLoading(false);
        }
      });
    } else {
      setLoading(false);
    }
  };
  const removeDevice = (record: IDevice) => {
    setLoading(false);
    if (
      localStorage.getItem("onAuth") === "true" &&
      localStorage.getItem("gid") !== ""
    ) {
      fetch(
        `${process.env.REACT_APP_API_URL}ApiPostJsonDeviceList_Delete.ashx`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: localStorage.getItem("token") || "",
          },
          body: JSON.stringify({
            Gid: localStorage.getItem("gid"),
            Did: record.Did,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.Data !== null && res.Data.length !== 0) {
            fetchDevice();
            setLoading(false);
            alert(res.InfoGet[0].Desc);
          } else {
            setLoading(false);
            alert(res.InfoGet[0].Desc);
          }
        });
    } else {
      setLoading(false);
    }
  };
  const addDevice = () => {
    setLoading(true);
    if (
      localStorage.getItem("onAuth") === "true" &&
      localStorage.getItem("gid") !== ""
    ) {
      fetch(`${process.env.REACT_APP_API_URL}ApiPostJsonDeviceList_Add.ashx`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: localStorage.getItem("token") || "",
        },
        body: JSON.stringify({
          DeviceUUID: addItem.DeviceUUID,
          DeviceName: addItem.DeviceName,
          Gid: localStorage.getItem("gid"),
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setAddItem({
            DeviceUUID: "",
            DeviceName: "",
            Gid: "",
          });
          alert(res.InfoGet[0].Desc);
          fetchDevice();
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
    setShow(false);
  };
  const removeAll = () => {
    let result = window.confirm("确定删除已勾选项目？");
    if (result === true && localStorage.getItem("onAuth") === "true") {
      setLoading(true);
      fetch(
        `${process.env.REACT_APP_API_URL}ApiPostJsonDeviceList_Delete.ashx`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: localStorage.getItem("token") || "",
          },
          body: JSON.stringify({
            Gid: localStorage.getItem("gid"),
            Did: selected.toString(),
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          fetchDevice();
          alert(res.InfoGet[0].Desc);
          setLoading(false);
        });
    } else {
      setLoading(false);
      return;
    }
  };
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const extensionName = e.target.value.split(".").pop();
    if (extensionName === "xlsx" || extensionName === "xls") {
      setUploadData(e.target.files?.[0] || null);
      setFileDetail(true);
    } else {
      alert("请确认档案类型为xls、xlsx");
    }
  };
  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("file", uploadData);
    fetch(
      `${
        process.env.REACT_APP_API_URL
      }ApiPostJsonDeviceImportExcel.ashx?Gid=${localStorage.getItem(
        "gid"
      )}&Type=${uploadType}`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: localStorage.getItem("token") || "",
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.InfoGet[0].Status === "Fail") {
          alert(res.InfoGet[0].Desc);
        } else if (res.InfoGet[0].Status === "existDevice") {
          if (localStorage.getItem("character") === "Admin") {
            let result = [];
            for (const [key, value] of Object.entries(res.Data as Obj[])) {
              result.push(
                `【${key}】踏板已存在于 ${value.replace(/ /g, "-")}鸽会`
              );
            }
            alert(result);
          } else {
            alert(`${Object.keys(res.Data)}踏板编号已存在于其它鸽会`);
          }
        } else if (res.InfoGet[0].Status === "IDError") {
          dispatch({ __CLEAR_ALL: true });
        } else {
          setUploadData(null);
          setFileDetail(false);
          preventRefreshCount(fetchDevice, 5);
          setMutipleShow(false);
          setChecked(false);
          setUploadType(0);
        }
      })
      .catch((err) => console.log("error", err));
  };
  const checkChange = (e: React.MouseEvent<HTMLElement>) => {
    if (!(e.target as HTMLInputElement).checked) {
      setUploadType(0);
      setChecked(false);
    } else if ((e.target as HTMLInputElement).checked) {
      setUploadType(1);
      setChecked(true);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("onAuth") === "true") {
      preventRefreshCount(fetchDevice, 5);
    }
  }, [state?.gid]);
  useEffectOnce(() => {
    setUpdateValue({
      ...updateValue,
      Gid: localStorage.getItem("gid") || "",
    });
  }, []);
  useEffect(() => {
    handleAuth();
  }, [deviceList, state?.gid]);
  return (
    <DefaultLayout>
      <EditableForm
        editable={editable}
        updateValue={updateValue}
        setEditable={setEditable}
        setUpdateValue={setUpdateValue}
        updateDevice={updateDevice}
      />
      <Container>
        <Spin spinning={spinLoading} tip={"请等候3秒"}>
          <FunctionBar
            show={show}
            checked={checked}
            mutipleShow={mutipleShow}
            fileDetail={fileDetail}
            addItem={addItem}
            setShow={setShow}
            setMutipleShow={setMutipleShow}
            setAddItem={setAddItem}
            removeAll={removeAll}
            addDevice={addDevice}
            handleEnter={handleEnter}
            updateDevice={updateDevice}
            uploadData={uploadData}
            checkChange={checkChange}
            handleUpload={handleUpload}
            handleSubmit={handleSubmit}
            clubList={clubList}
          />
          <TableOutter>
            <Table
              className="bordered-table"
              columns={columns}
              rowSelection={{
                selectedRowKeys: selected,
                onChange: selectOnChange,
              }}
              dataSource={deviceList}
              pagination={false}
              scroll={{ x: "scroll" }}
              rowKey="Did"
              size={"small"}
              loading={loading}
              sticky
              bordered
            />
          </TableOutter>
        </Spin>
      </Container>
    </DefaultLayout>
  );
};

export default DeviceList;
